// extracted by mini-css-extract-plugin
export default {"card":"blogSubscribePrompt_card__ESzI5","heading":"blogSubscribePrompt_heading__H8vQQ","description":"blogSubscribePrompt_description__HgWfN"};